<template>
  <li class="cat-tree-item">
  <div  @click="selectCat(item)">
    <span v-if="item.desc">{{ item.desc.short_des }}</span>
    <span v-if="!item.desc">{{ item.map_id }}</span>
  </div>
  <ul class="cat-tree" v-if="item.children && open">
    <CatTreeItem @selected="passSelected" v-for="child in item.children" :key="child.map_id" :item="child"/>
  </ul>
</li>
</template>

<script>
export default {
  name: 'CatTreeItem',
  props: ["item"],
  data() {
    return {
      open: false
    }
  },
  methods: {
    selectCat: function (cat) {
      this.open = !this.open;
      this.$emit('selected',{ cat: cat});
    },
    passSelected: function(cat) {
      this.$emit('selected',cat);
    }
  }
}
</script>
